import type { ComponentPropsWithoutRef } from 'react';

export const RealtyFilterChevron = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" {...props}>
    <path
      d="M6 8L10 12L14 8"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.575"
    />
  </svg>
);
